"use client";

import { useEffect, useRef } from "react";
import { Clock, Shield, FileText, MessageCircle } from "lucide-react";
import { trackFAQInteraction } from "@/app/lib/analytics";

const FAQ_ITEMS = [
  {
    icon: <Clock size={18} />,
    q: "\u00bfCu\u00e1nto tarda la verificaci\u00f3n de identidad?",
    a: "La verificaci\u00f3n de identidad (KYC) puede tomar entre 24 y 72 horas h\u00e1biles. Te notificaremos por email cuando est\u00e9 lista.",
  },
  {
    icon: <Shield size={18} />,
    q: "\u00bfEs segura la app?",
    a: "S\u00ed. Utilizamos encriptaci\u00f3n de datos, autenticaci\u00f3n segura a trav\u00e9s de AWS Cognito y seguimos las mejores pr\u00e1cticas de seguridad de la industria.",
  },
  {
    icon: <FileText size={18} />,
    q: "\u00bfTiene costo usar Finbo?",
    a: "La descarga, el registro y el uso de la app son 100% gratuitos. No hay costos ocultos de apertura ni mantenimiento.",
  },
  {
    icon: <MessageCircle size={18} />,
    q: "\u00bfC\u00f3mo puedo eliminar mi cuenta?",
    a: "Desde la app: Perfil, Configuraci\u00f3n, Eliminar cuenta. Se borran tus gastos y metas y la cuenta queda cerrada. Si prefer\u00eds, tambi\u00e9n pod\u00e9s escribirnos a finbo.ad@gmail.com desde tu email registrado.",
  },
];

export default function FAQList() {
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const trackedRef = useRef<Set<number>>(new Set());

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;

    const tracked = trackedRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = Number((entry.target as HTMLElement).dataset.faqIndex);
          if (!isNaN(index) && !tracked.has(index)) {
            tracked.add(index);
            trackFAQInteraction(index, FAQ_ITEMS[index].q);
          }
        });
      },
      { threshold: 0.5 },
    );

    itemRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="space-y-4">
      {FAQ_ITEMS.map((faq, i) => (
        <div
          key={i}
          ref={(el) => {
            itemRefs.current[i] = el;
          }}
          data-faq-index={i}
          className="glass rounded-xl p-5 sm:p-6"
        >
          <div className="flex gap-3 items-start">
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0 mt-0.5">
              {faq.icon}
            </div>
            <div>
              <h3 className="font-semibold mb-2">{faq.q}</h3>
              <p className="text-white/40 text-sm leading-relaxed">{faq.a}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
